import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom';
import styles from './QISoftware.module.scss';

const SASQIAccordions = () => {
    return (<>

        <Container className="outerContainer">
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Software Instructions & Release Notes</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Software Instructions</h4>
                                <p>Software Instructions (SAS QI) Version v2021, July 2021.</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/Software_Inst_SASQI_v2021_July_2021.pdf">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>v2021 Software Release Notes</h4>
                                <p>Version v2021, July 2021 - Summary of the major changes from v2020 to v2021 of the Technical Specifications and AHRQ QI Software.</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/AHRQ_SASQI_v2021_Software_Rel_Notes.pdf">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Software Tutorial Video</h4>
                                <p>To learn more about how to use the software, view the SAS QI tutorial video.</p>
                            </Col>
                            <Col md={2}>
                                <Button href="https://www.youtube.com/watch?v=KIG5u-t81CY"> 
                                    View Video
                                </Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Automate SAS QI Software Runs in Windows, v2021</h4>
                                <p>This document demonstrates how to schedule automated Agency for Healthcare Research and Quality (AHRQ) Quality Indicator (QI) SAS QI Software runs on a Windows computer.</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/Automate_SAS_QI_Software_Runs_in_Windows.pdf">Download</Button>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Population File Resources</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>2000-2021 Population Files</h4>
                                <p>Population figures through 2020 for use with SAS QI v2021</p>
                                <p className="subtitle">Version v2021 (July 2021)</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/2000-2020_Population_Files_V2021.zip">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>AHRQ QI 2000-2020 Population File Documentation</h4>
                                <p>This document is to describes how the population data estimates are derived from public use Census data for use with the QI SAS® v2021</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/AHRQ_QI_v2021_ICD10_Population_File.pdf">Download</Button>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Indicator Technical Resources</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Prevention Quality Indicators (PQI)</h4>
                                <p>PQI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                                <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/PQI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Inpatient Quality Indicators (IQI)</h4>
                                <p>IQI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                                <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/IQI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Patient Safety Indicators (PSI)</h4>
                                <p>PSI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                                <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/PSI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Pediatric Quality Indicator (PDI)</h4>
                                <p>PDI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                                <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/PDI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="3">
                    <Accordion.Header>SAS QI ICD-10 Archives</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>SAS QI v2020 ICD-10-CM/PCS Full Software Package July 2020)</h4>
                                <p>The QI/STAT modules are programs that run in the SAS statistical software package. To use these modules, users must have access to SAS which may be purchased from The SAS Institute.</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2020/SAS_V2020_ICD-10-CM-PCS_QI_Software.zip">Get ICD-10 Software</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>SAS QI v2019.0.1 ICD-10-CM/PCS (Full Software Package September 2019)</h4>
                                <p>The QI/STAT modules are programs that run in the SAS statistical software package. To use these modules, users must have access to SAS which may be purchased from The SAS Institute.</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2019/SAS_V201901_ICD-10-CM-PCS_QI_Software.zip">Get ICD-10 Software</Button>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Link to="/archive/software?1#SAS-Release-Notes">Get Archived SAS QI Software</Link>
        </Container>

    </>)
}

export default SASQIAccordions;